export default (theme) => ({
    cell: {
        color: "white",
        fontWeight: "bold",
    },
    row: {
        backgroundColor: "black",
    },
});
